import AccurityIcon from '../../../icon/components/AccurityIcon';
import { objectTypeToIconName } from '../../../icon/utils';
import * as React from 'react';
import { Box, Chip, DialogTitle as DialogTitleMui, Stack } from '@mui/material';
export var DialogTitle = function (_a) {
    var triggeredFrom = _a.triggeredFrom, isAllSource = _a.isAllSource, dataStructuresCount = _a.dataStructuresCount;
    return (React.createElement(DialogTitleMui, null,
        React.createElement(Stack, { direction: "row", spacing: 1 },
            React.createElement(Box, { mr: 1 }, (isAllSource ? 'Create' : 'Synchronize') + " Data Structure" + (dataStructuresCount > 1 ? 's' : '')), triggeredFrom === null || triggeredFrom === void 0 ? void 0 :
            triggeredFrom.map(function (reference) {
                return (React.createElement(Chip, { key: reference.objectType + "-" + reference.id, label: reference.name, icon: React.createElement(AccurityIcon, { iconName: objectTypeToIconName(reference.objectType) }), clickable: false }));
            }))));
};
//# sourceMappingURL=DialogTitle.js.map